/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import './Nav.css';
import {AiOutlineHome} from 'react-icons/ai'
import {AiOutlineUser} from 'react-icons/ai'
import {BiBook} from 'react-icons/bi'
import {RiServiceLine} from 'react-icons/ri'
import {BiMessageSquareDetail} from 'react-icons/bi'
import { useState } from 'react';

const Nav = () => {
  const [activeNav,setActiveNav]=useState('#')
  return (
    <nav>
      <a href="#" className={activeNav==='#'?'active':''}  onClick={()=>setActiveNav('#')}><AiOutlineHome/></a>
      <a href="#about" onClick={()=>setActiveNav('#about')}   className={activeNav==='#about'?'active':''} ><AiOutlineUser/></a>
      <a href="#experience" className={activeNav==='#experience'?'active':''} onClick={()=>setActiveNav('#experience')} ><BiBook/></a>
      <a href="#services" className={activeNav==='#services'?'active':''}  onClick={()=>setActiveNav('#services')}><RiServiceLine/></a>
      <a href="#contacts" className={activeNav==='#contacts'?'active':''} onClick={()=>setActiveNav('#contacts') }><BiMessageSquareDetail/></a>
    </nav>
  )
}

export default Nav